export default "__VITE_ASSET__CBprbx_H__"